import type { ApiDeviceProfile } from "../_types/device-profiles.types";

/** In-memory sample profiles for the UI-only Profiles prototype. Not assignable to real devices. */
export const DEVICE_PROFILE_PROTOTYPE_SAMPLES: ApiDeviceProfile[] = [
  {
    id: "11111111-1111-4111-8111-111111111101",
    name: "Kiosk — reception",
    description: "Single-app kiosk with locked settings and curated launcher.",
    config: {
      schemaVersion: 1,
      mode: "kiosk",
      allowUsb: false,
      idleLockMinutes: 5,
    },
    configVersion: 3,
    createdAt: Date.UTC(2026, 2, 10, 12, 0, 0),
    updatedAt: Date.UTC(2026, 2, 18, 12, 0, 0),
  },
  {
    id: "11111111-1111-4111-8111-111111111102",
    name: "Clinical floor tablet",
    description: "Multi-app clinical shell with USB storage restricted.",
    config: {
      schemaVersion: 1,
      mode: "multi_app",
      allowUsb: false,
      wifiPolicy: "clinic_only",
    },
    configVersion: 2,
    createdAt: Date.UTC(2026, 2, 8, 12, 0, 0),
    updatedAt: Date.UTC(2026, 2, 16, 12, 0, 0),
  },
  {
    id: "11111111-1111-4111-8111-111111111103",
    name: "Shared station timeout",
    description: "Idle logout and cleared temp data for shared PACS stations.",
    config: {
      schemaVersion: 1,
      sessionTimeoutMinutes: 10,
      clearTempOnLogout: true,
    },
    configVersion: 1,
    createdAt: Date.UTC(2026, 2, 5, 12, 0, 0),
    updatedAt: Date.UTC(2026, 2, 12, 12, 0, 0),
  },
];

export function createPrototypeProfileId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `00000000-0000-4000-8000-${String(Date.now()).padStart(12, "0").slice(-12)}`;
}
